module.exports = __webpack_public_path__ + "static/LOGO-2-1771a720a902a9d9fe3a62b9bbf3fbbe.webp";